import PublishContent from './PublishContent';

export default PublishContent;
